<template>
  <v-navigation-drawer
      v-model="drawer"
      app
    >
    <v-list dense>
      <v-list-item link to="/estimates">
        <v-list-item-action>
          <v-icon>mdi-view-list</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Мои сметы</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/constructor">
        <v-list-item-action>
          <v-icon>mdi-axis-arrow</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Конструктор сметы</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'main-menu',
  
  props: {
    value: Boolean
  },

  data() {
    return {
      drawer: this.value
    }
  },

  watch: {
    value(val, oldVal) {
      this.drawer = val;
    },

    drawer(val, oldVal) {
      this.$emit('input', val);
    }
  },
}
</script>